import { type ClientInferRequest } from "@ts-rest/core";

import { client } from "../client";
import { type apiContract } from "../contract";

import type { UpdateTillRequest } from "./types";

export async function getTill(id: string) {
  const response = await client.v1.pos.tills.getById({
    params: { tillId: id }
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}

type GetTillsRequest = ClientInferRequest<typeof apiContract.v1.pos.tills.get>;

export async function getTills(query: GetTillsRequest["query"]) {
  const response = await client.v1.pos.tills.get({
    query
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}

export async function updateTill(id: string, body: UpdateTillRequest["body"]) {
  const response = await client.v1.pos.tills.update({
    params: { tillId: id },
    body
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}
